import config from 'constants/config'
import { getFirstFlashPricePerPerson } from './addBundlePriceToTourOffer'

export const BUNDLED_TOUR_ID = 'tour-e8c5e5c1-7eae-430d-91e4-aeb9a670258c'

export default function tourBundleOfferPageStatus(
  tourId: string,
  currency: string,
  offer: App.Tours.TourV2Offer | undefined,
  bundleState: App.StatefulData<App.Tours.Bundle, unknown> | undefined,
): 'loading' | 'ready' | 'error' {
  if (config.APP_ENV === 'production' || tourId !== BUNDLED_TOUR_ID || currency !== 'AUD') return 'ready'
  if (bundleState?.error) return 'ready'
  if (!bundleState?.data || !offer) return 'loading'
  if (getFirstFlashPricePerPerson(bundleState.data) === undefined) return 'ready'

  const audOptions = Object.values(offer.departures)
    .filter(departure => !departure.currencyCode || departure.currencyCode === 'AUD')
    .flatMap(departure => departure.options)

  return audOptions.every(option => option.bundledPrice !== undefined) ? 'ready' : 'error'
}
